
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { PosterManager, } from "../../independent/poster/PosterManager";
import { SanBackground } from "../../background/SanBackground";
import { JumpingWildCollector } from "../../independent/collector/JumpingWildCollector";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { ReelOverlay } from "../../background/ReelOverlay";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { SplashBrokenBank } from "../../independent/splashScreen/views/SplashBrokenBank";

export class BrokenBankOutro extends Presentation {

    protected totalWinAmount:number = 0;

    private stateNr:number = 0;

    public setParsedGamedData(data:SanParsedGameData):void{
        this.totalWinAmount = data.totalWin;
        SplashBrokenBank.setTotalWinAmount(data.totalWin);
        SplashController.instance.setResultTotal({ fs:data.numberOfFreespinsPlayed!,jwData:data.sanJumpData});
    }

    public checkForActivation(data:SanParsedGameData):boolean{ return data.rawData.brokeTheBank};

    preStart():void{
        this.stateNr = 0;

        SanEngineManager.setFSSymbol("",0);
        RevealerManager.setFSSymbol("",0);
    }

    public getPresentation(){

        EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
        if(this.stateNr == 0){
            this.pTimeline.add([
                () => EventHandler.dispatchEvent(new GameEvent(SpinEvent.DONE)),
                () => SlotGame.keypad.setZeroBetSpinCounter(-1),
                () => SanBackground.instance.playAtmosphere(0),
                PosterManager.instance.setBlackScreenAlpha(0,1),
                ReelOverlay.instance.changeAlpha(0, 1),
                SanBackground.instance.changeBgBlackness(0,1),
                SanBackground.instance.stopCheering(),
                SanBackground.instance.changeBgManiacBlackness(1,1)
            ],0)

            this.pTimeline.add(() => SplashController.instance.play(4,() => this.clicked()),1);
            
            this.pTimeline.to(this,Number.MAX_SAFE_INTEGER,{});

            this.stateNr = 1;
        }else{
            SoundManager.SwitchFStoMain();
            JumpingWildController.instance.cleanItems();
            JumpingWildCollector.instance.reset();
            
            SanBackground.instance.restoreOverlay(3);
            
            this.pTimeline.add(SanBackground.instance.moveBG(false));
            this.pTimeline.to(this,0.4,{});
            this.PresentationState.set(PresentationState.INACTIVE);
        }
    }

    clicked():void{
        SplashController.instance.stop();
        this.pTimeline.totalProgress(1);
    }
}